module.exports = __webpack_public_path__ + "img/img1.92c99572.jpg";